import { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router';
import { useAuth } from '../auth/AuthContext';

const useIsApple = () => {
  const [isApple, setIsApple] = useState(false);
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(ua);
    setIsApple(isIOS || isIPadOS || isMac);
  }, []);
  return isApple;
};

const AppBanner = () => {
  const { user, isAuthenticated } = useAuth();
  const isIOS = useIsApple();
  const [dismissed, setDismissed] = useState(false);

  if (!isAuthenticated || !user?.isActive || dismissed) return null;

  if (isIOS) {
    return (
      <Alert
        variant="dark"
        dismissible
        onClose={() => setDismissed(true)}
        className="mb-3 mt-2 py-2"
        style={{ borderRadius: '8px', border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
      >
        <div className="d-flex align-items-center">
          <i className="bi bi-apple me-2" style={{ fontSize: '1.25rem' }}></i>
          <span>
            iOS App 現已開放！
            <Link to="/ios-app" className="ms-2 fw-bold text-light">
              查看詳情
            </Link>
          </span>
        </div>
      </Alert>
    );
  }

  return (
    <Alert
      variant="success"
      dismissible
      onClose={() => setDismissed(true)}
      className="mb-3 mt-2 py-2"
      style={{ borderRadius: '8px', border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
    >
      <div className="d-flex align-items-center">
        <i className="bi bi-android2 me-2" style={{ fontSize: '1.25rem', color: '#3ddc84' }}></i>
        <span>
          Android 版 App 已上線！
          <Link to="/download" className="ms-2 fw-bold">
            立即下載
          </Link>
        </span>
      </div>
    </Alert>
  );
};

export default AppBanner;
